







import { Vue, Component, Prop } from "vue-property-decorator";
import { CoordIndicatorModule } from "@/modules/CoordIndicatorModule";
import { dom } from "@/utils/dom";
import { Frame, store } from "@/store";
import { EquatorialCoord, rad2amin, rad2deg } from "@hscmap/angle";
import { angle60html } from "@/utils/angle";
import { sprintf } from 'sprintf-js';
import { CoordFormat } from '../../utils/coord_format';
// import { ITic } from '../RulerModule';
import { queryParams } from '../../utils/query_params';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: CoordIndicatorModule

  @Prop({ required: true })
  frame!: Frame

  get coordInfo() {
    const { a, d, fovy } = this.frame.view
    const coord = EquatorialCoord.fromRad(a, d)
    switch (this.module.coordFormat) {
      case CoordFormat.SEXADECIMAL: {
        const { a: a60, d: d60 } = coord.toString()
        const angle = angle60html(2 * fovy)
        return `&alpha;=${a60} &delta;=${d60} &angle;=${angle}`
      }
      case CoordFormat.DECIMAL: {
        const { a: aAng, d: dAng } = coord
        return sprintf(`&alpha;=%08.6f&deg; &delta;=%08.6f&deg; &angle;=%08.6f`, aAng.deg, dAng.deg, rad2deg(2 * fovy))
      }
    }
  }

  copyCoordToClipboard() {
    dom.pbcopy(this.coordInfo, true)
  }

  async zoom(a: number) {
    const z = Math.pow(2, a)
    const globe = store.globe(this.frame)
    const vf = globe.viewFactory
    await vf.jumpTo({ fovy: vf.fovy * z })
    vf.cage()
  }
}
